import { InjectionToken } from '@angular/core';
import { LOGIN_TYPE } from '../entra-id-config';

export const LOGIN_BEHAVIOR = new InjectionToken<LOGIN_TYPE>(LOGIN_TYPE.REDIRECT);
